import { MandatoryUpdateBannerState } from '../interfaces/mandatoryUpdateBanner';
import Actions from '../actions/actions';

const initialState: MandatoryUpdateBannerState = {
  mandatoryUpdate: false,
  recommendedUpdate: false,
  secondsToReload: undefined,
};

export default function mandatoryUpdateBanner(
  state = initialState,
  action: any,
) {
  switch (action.type) {
    case Actions.RESET:
    case Actions.DISMISS_UPDATE_NOTIFICATION:
      return initialState;
    case Actions.NOTIFY_MANDATORY_UPDATE:
      return {
        ...state,
        mandatoryUpdate: true,
        secondsToReload: action.secondsToReload,
      };
    case Actions.NOTIFY_RECOMMENDED_UPDATE:
      return {
        ...state,
        recommendedUpdate: true,
        secondsToReload: action.secondsToReload,
      };
    default:
      return state;
  }
}
